import { friendlyApiErrorMessage } from 'src/app/services/api-error-notifier.service';
import { HttpClient } from '@angular/common/http';
import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  OnInit,
  SimpleChanges,
  AfterViewInit,
  OnDestroy,
  HostListener,
  Output,
  EventEmitter,
} from '@angular/core';
import * as d3 from 'd3';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { DataService } from 'src/app/services/data.service';
import { FilterService } from 'src/app/services/filter.service';
import { CurrencyPipe } from '@angular/common';
// import { DonutChartConfig, DonutChartSegment } from './donut-chart.model';

@Component({
    selector: 'app-donut-chart-new-card',
    templateUrl: './donut-chart-new-card.component.html',
    styleUrls: ['./donut-chart-new-card.component.scss'],
    standalone: false
})
export class DonutChartNewCardComponent implements OnInit, AfterViewInit, OnDestroy {
  static key = 101004;
  @Input() item: any = {};
  @Input() pageKey: any;

  @Input() config!: any;
  @ViewChild('chartContainer') chartContainer!: ElementRef<HTMLDivElement>;
  
  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();
  @ViewChild("DonutNewChartDiv", { static: true }) DonutNewChartDiv!: ElementRef;

  reqSubcription: Subscription[] = [];
  // Chart dimensions - now dynamic
  private chartSize = 160;
  private readonly margin = 5;
  private radius = (this.chartSize - this.margin * 2) / 2;
  private donutThickness = 10;
  private resizeTimeout: any;
  private tooltip: any;
  private tooltipId: string = `donut-tooltip-${Math.random().toString(36).substr(2, 9)}`;

  scriptsConfiguration:any = {
    title: 'Total Scripts Cancelled',
    centerLabel: 'Total Cancelled Scripts',
    centerValue: 591,
    segments: [
      { name: 'Rejection', value: 342, color: '#8B5CF6' },
      { name: 'Abandonment', value: 106, color: '#3DDBCC' },
      { name: 'Insurance denial', value: 153, color: '#F04438' }
    ],
    showPercentages: true,
    showValues: true,
    donutThickness: 20,
  };

  // Calculated data
  legendItems: Array<{
    name: string;
    value: number;
    percentage: string;
    color: string;
  }> = [];
  totalValue = 0;
  loader  = true;
  data: any = [];
  error_name:any;
  
  view: 'flex' | 'block' = "flex";

  // When configured, force a fixed height for the widget; otherwise keep the
  // natural/auto height driven by the content + ResizeObserver.
  designerChartHeight: number | null = null;

  constructor(
    private filterService: FilterService,
    private httpClient: HttpClient,
    private apiService: ApiService,
    private dataService: DataService,
    private currency: CurrencyPipe
  ) {}
  
  ngOnInit(): void {
    
    this.reqSubcription.push(
      this.filterService.filterQuery.subscribe(() => {
        this.loader = true;
        this.loadApiData();
      })
    );

    const observer = new ResizeObserver((entries: any) => {
      setTimeout(() => {
        this.onSizeChange.emit(entries[0].contentRect.height);
      }, 0); // Defers execution to the next event loop cycle
    });
    observer.observe(this.DonutNewChartDiv?.nativeElement);

    this.scriptsConfiguration['title'] = this.item.config?.['report_heading'] || '';
    this.scriptsConfiguration['centerLabel'] = this.item.config?.['center_label'] || '';

    this.view = this.item.config?.['viewMode']?.value || 'flex';
    const designerHeight = this.item.config?.['designer_chart_height'];
    this.designerChartHeight = designerHeight ? Number(designerHeight) : null;

    // this.config = this.scriptsConfiguration;
    // this.calculateLegendData();
    // this.renderChart();
  }

  ngAfterViewInit(): void {
    // if (this.config) {
      this.initializeTooltip();
    //   // Defer so the browser has finished laying out the DOM before we
    //   // measure offsetWidth and draw the D3 chart.
    //   setTimeout(() => {
    //     this.updateChartSize();
    //     this.renderChart();
    //   });
    // }
  }

  @HostListener('window:resize')
  onResize(): void {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout(() => {
      this.updateChartSize();
      this.renderChart();
    }, 150);
  }

  /**
   * Update chart size based on container width
   */
  private updateChartSize(): void {
    if (!this.chartContainer) return;
    
    const containerWidth = this.chartContainer.nativeElement.offsetWidth;
    // Only update if the container has a positive measured width; otherwise
    // keep the default 160px so the radius never becomes zero or negative.
    if (containerWidth > 0) {
      this.chartSize = Math.min(containerWidth, 200);
    }
    this.radius = (this.chartSize - this.margin * 2) / 2;
  }

  /**
   * Calculate total and percentages for legend
   */
  private calculateLegendData(): void {
    if (!this.config || !this.config.segments) return;

    this.totalValue = this.config.segments.reduce(
      (sum:any, segment:any) => sum + segment.value,
      0
    );

    this.legendItems = this.config.segments.map((segment:any) => ({
      name: segment.name,
      value: segment.value,
      percentage: segment.percentage + '%',
      // percentage: ((segment.value / this.totalValue) * 100).toFixed(0) + '%',
      color: segment.color,
    }));
  }

  /**
   * TrackBy function for legend items to improve performance
   */
  trackByLabel(index: number, item: any): string {
    return item.name;
  }

  /**
   * Render the D3 donut chart
   */
  private renderChart(): void {
    if (!this.chartContainer) return;

    const container = this.chartContainer.nativeElement;
    
    // Clear previous chart
    d3.select(container).selectAll('*').remove();

    // Set donut thickness from config or default
    this.donutThickness = this.config.donutThickness || 20;

    // Create SVG
    const svg = d3
      .select(container)
      .append('svg')
      .attr('width', this.chartSize)
      .attr('height', this.chartSize)
      .attr('viewBox', `0 0 ${this.chartSize} ${this.chartSize}`)
      .attr('preserveAspectRatio', 'xMidYMid meet');

    // Create group for the chart
    const chartGroup = svg
      .append('g')
      .attr(
        'transform',
        `translate(${this.chartSize / 2}, ${this.chartSize / 2})`
      );

    // Create arc generator with rounded corners
    const arc = d3
      .arc<any>()
      .innerRadius(this.radius - this.donutThickness)
      .outerRadius(this.radius)
    //   .cornerRadius(3); // Rounded corners

    // Create pie generator
    const pie = d3
      .pie<any>()
      .value((d) => d.value)
      .sort(null)
    //   .padAngle(0); // Small gap between segments

    // Generate pie data
    const pieData = pie(this.config.segments);

    // Draw donut segments with tooltip interactions
    const self = this;
    chartGroup
      .selectAll('path')
      .data(pieData)
      .enter()
      .append('path')
      .attr('d', arc)
      .attr('fill', (d) => d.data.color)
      .attr('stroke', '#ffffff')
      .attr('stroke-width', 0.5)
      .style('transition', 'all 0.3s ease')
      .style('cursor', 'pointer')
      .on('mouseenter', function(event, d) {
        d3.select(this)
          .transition()
          .duration(200)
          .attr('opacity', 0.8)
          .attr('transform', 'scale(1.05)');
        self.showTooltip(event, d.data);
      })
      .on('mousemove', function(event, d) {
        self.updateTooltipPosition(event);
      })
      .on('mouseleave', function(event, d) {
        d3.select(this)
          .transition()
          .duration(200)
          .attr('opacity', 1)
          .attr('transform', 'scale(1)');
        self.hideTooltip();
      });

    // Add center label + value as a vertically centered group inside the donut.
    // Word-wraps the label (never splits a word) based on inner-circle width.
    this.renderCenterText(chartGroup, this.config.centerLabel || '');
  }

  /**
   * Render the center label (wrapped at word boundaries) and the value below it,
   * centered as a group around the donut's center (y=0).
   */
  private renderCenterText(container: any, labelText: string): void {
    const labelFontSize = 10;
    const valueFontSize = 16;
    const lineHeight = 1.2;
    const gap = 4;
    const horizontalPadding = 20; // 10px on each side, keeps label off the donut edge
    const innerDiameter = 2 * (this.radius - this.donutThickness);
    const maxWidth = Math.max(innerDiameter - horizontalPadding, 0);

    // Label element — wrap by words, never split a word.
    const labelEl = container
      .append('text')
      .attr('text-anchor', 'middle')
      .style('font-size', `${labelFontSize}px`)
      .style('font-weight', '500')
      .style('fill', '#6b7280');

    const words = labelText.split(/\s+/).filter(Boolean);
    let line: string[] = [];
    let lineCount = 0;
    let tspan = labelEl.append('tspan').attr('x', 0).attr('dy', '0em');

    words.forEach((word) => {
      line.push(word);
      tspan.text(line.join(' '));
      if (tspan.node().getComputedTextLength() > maxWidth && line.length > 1) {
        line.pop();
        tspan.text(line.join(' '));
        line = [word];
        tspan = labelEl
          .append('tspan')
          .attr('x', 0)
          .attr('dy', `${lineHeight}em`)
          .text(word);
        lineCount++;
      }
    });
    lineCount++; // count the final/active line

    // Center the label + value block around y=0
    const labelHeight = lineCount * labelFontSize * lineHeight;
    const totalHeight = labelHeight + gap + valueFontSize;
    const top = -totalHeight / 2;

    // First baseline of label sits ~0.85em below the block top
    labelEl.attr('y', top + labelFontSize * 0.85);

    // Value below the label
    container
      .append('text')
      .attr('text-anchor', 'middle')
      .attr('x', 0)
      .attr('y', top + labelHeight + gap + valueFontSize * 0.85)
      .style('font-size', `${valueFontSize}px`)
      .style('font-weight', '700')
      .style('fill', '#1f2937')
      .text(this.numbedPipe(this.config.centerValue));
  }
  numbedPipe(value: any) {
    if (value == 'NA') return value
    return this.currency.transform(value, '', '', '1.0-2');
    //  return   this.numberpipe.transform(value)
  }

  /**
   * Initialize tooltip
   */
  private initializeTooltip(): void {
    // Remove existing tooltip for this specific instance if any
    d3.select(`#${this.tooltipId}`).remove();

    this.tooltip = d3.select('body')
      .append('div')
      .attr('id', this.tooltipId)
      .attr('class', 'donut-tooltip')
      .style('position', 'absolute')
      .style('pointer-events', 'none')
      .style('opacity', 0)
      .style('z-index', '1000')
      .style('background', '#ffffff')
      .style('border', '1px solid #e5e7eb')
      .style('border-radius', '8px')
      .style('padding', '12px 14px')
      .style('box-shadow', '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06), 0 10px 15px -3px rgba(0, 0, 0, 0.1)')
      .style('font-family', '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif')
      .style('font-size', '13px')
      .style('line-height', '1.5')
      .style('min-width', '200px')
      .style('max-width', '300px');
  }

  /**
   * Show tooltip with segment data
   */
  private showTooltip(event: any, data: any): void {
    const segmentName = data.name || 'Unknown';
    const segmentValue = data.value || 0;
    const percentage = data.percentage || 0
    // const percentage = this.totalValue > 0 
    //   ? ((segmentValue / this.totalValue) * 100).toFixed(1) 
    //   : '0.0';
    const segmentColor = data.color;

    const tooltipContent = `
      <div class="du-scri-tooltip" style="display: flex; align-items: center; gap: 10px; color: #fff; font-size: 13px; line-height: 1.4;">
        <div class="bullet" style="width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; background-color: ${segmentColor}; box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);"></div>
        <span style="flex: 1; word-break: break-word; color: #fff; font-weight: 400;font-family: 'Poppins';">
          <strong>${segmentName}</strong>
        </span>
      </div>
      <hr style="border: none; border-top: 1px solid rgb(255, 255, 255); margin: 8px 0;">
      <div class="du-scri-tooltip-body" style="display: flex; flex-direction: column; gap: 8px;">
        <div class="du-scri-tooltip-item" style="display: flex; align-items: center; gap: 10px; color: #fff; font-size: 13px; line-height: 1.4;">
          <span style="flex: 1; word-break: break-word; color: #fff; font-weight: 400;font-family: 'Poppins';">
            Value: ${segmentValue.toLocaleString()}
          </span>
        </div>
        <div class="du-scri-tooltip-item" style="display: flex; align-items: center; gap: 10px; color: #fff; font-size: 13px; line-height: 1.4;">
          <span style="flex: 1; word-break: break-word; color: #fff; font-weight: 400;font-family: 'Poppins';">
            Percentage: ${percentage}%
          </span>
        </div>
      </div>
    `;

    this.tooltip
      .html(tooltipContent)
      .style('display', 'block')
      .style('background', 'black')
      .style('opacity', 0);

    this.updateTooltipPosition(event);

    this.tooltip
      .transition()
      .duration(200)
      .style('opacity', 0.95);
  }

  /**
   * Update tooltip position to follow mouse
   */
  private updateTooltipPosition(event: any): void {
    const tooltipEl = this.tooltip.node() as HTMLElement;
    if (!tooltipEl) return;

    const tooltipWidth = tooltipEl.offsetWidth || 220;
    const tooltipHeight = tooltipEl.offsetHeight || 100;

    // Get mouse position
    const mouseX = event.pageX || event.clientX;
    const mouseY = event.pageY || event.clientY;

    const margin = 12;
    const winWidth = window.innerWidth;
    const winHeight = window.innerHeight;

    // --- Horizontal positioning ---
    let left = mouseX + 10;
    if (mouseX + tooltipWidth + margin > winWidth) {
      // Not enough space on right → show on left
      left = mouseX - tooltipWidth - margin;
    }
    left = Math.max(margin, left); // Prevent overflow on left

    // --- Vertical positioning ---
    let top = mouseY + 10; // Default: BELOW cursor
    if (mouseY + tooltipHeight + margin > winHeight) {
      // Not enough space below → show ABOVE cursor
      top = mouseY - tooltipHeight - margin;
    }
    top = Math.max(margin, top); // Prevent overflow on top

    // Final position
    this.tooltip
      .style('left', `${left}px`)
      .style('top', `${top}px`);
  }

  /**
   * Hide tooltip
   */
  private hideTooltip(): void {
    this.tooltip
      .transition()
      .duration(200)
      .style('opacity', 0)
      .on('end', () => {
        this.tooltip.style('display', 'none');
      });
  }

  loadApiData() {
    const kpi = this.item.config?.['list_of_api'];
    if (kpi?.api_key && !this.filterService.isEmptyObject(this.filterService.baseQuery)) {
      const obj: any = { api_key: kpi.api_key };
      const query = { ...this.filterService.baseQuery, ...obj, report_typ: this.filterService.report_type };
      
      let endPoint = this.item.config?.["list_of_api_endpoint"];
      
      this.reqSubcription.push(
        this.httpClient.post(`${this.apiService.apiBaseUrl}/${endPoint || this.apiService.executionUrl}`, query).subscribe(
          (res: any) => {
            this.error_name = '';
            this.data = (!res && res == null) ? [] : res;
            if (res && res.length > 0) {
              this.config = this.scriptsConfiguration;
              this.scriptsConfiguration["centerValue"] = res?.[0]?.['total_patients'];

              const colColor = this.item.config?.bar_Fill?.values || [];

              res = res.map((c:any) => {
                let findColor = colColor.find((f:any) => f.col_value == c.name);
                return { ...c, color: findColor?.color || '#ddd' }
              })
              this.scriptsConfiguration["segments"] = res || [];
  
              // console.log(this.scriptsConfiguration)
              setTimeout(() => {
                this.calculateLegendData();
                requestAnimationFrame(() => {
                  this.updateChartSize();
                  this.renderChart();
                });
              });
            }
            this.loader = false;
          },
          (err: any) => {
            this.data = []
            this.error_name = friendlyApiErrorMessage(err);
            this.loader = false;
          }
        )
      );
    }
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    // Remove tooltip from DOM by ID to avoid affecting other chart instances
    d3.select(`#${this.tooltipId}`).remove();
  }
}